export const CreateBookingErrorCodes = Object.freeze({
  /**
   * Fallback code used when the error response is absent or cannot be recognised.
   */
  Unknown: 'unknown',

  /**
   * One or more candidates in the booking templates are no longer valid.
   * The error data will contain an `invalidCandidateIds` array.
   */
  InvalidCandidatesInTemplates:
    'bookings_create_invalid_candidates_in_templates',

  /**
   * Booking creation is restricted for the selected location due to an active booking block.
   */
  BookingCreationRestrictedForLocation:
    'bookings_create_booking_creation_restricted_for_location',

  /**
   * Cannot edit a single day within a multi-day block booking while candidates are present.
   * The entire block must be edited instead.
   */
  SingleDayEditWithinBlockHasCandidates:
    'bookings_cannot_edit_single_day_within_block_with_candidates',

  /**
   * Multiple bookings were submitted without a group. A group must be provided, or the
   * bookings must be edited individually.
   */
  MultipleBookingsWithoutGroup: 'bookings_multiple_without_group',
})
